"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchTransport = void 0;
var error_1 = require("./error");
var serializer_1 = require("../serializer");
function fetchTransport() {
    var fetch = require('cross-fetch');
    return function fetchTransport(req) {
        return __awaiter(this, void 0, void 0, function () {
            var url, query, queryParams, fullPath, response, result, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = "" + req.host + req.url;
                        query = req.query || {};
                        if (req.format)
                            query.format = req.format;
                        queryParams = serializer_1.searchParams(query);
                        fullPath = "" + url + (queryParams.length > 0 ? "?" + queryParams : '');
                        return [4 /*yield*/, fetch(fullPath, {
                                method: req.method,
                                headers: req.headers,
                                body: req.body ? JSON.stringify(req.body) : null,
                            })];
                    case 1:
                        response = _b.sent();
                        _a = error_1.errorHandler;
                        return [4 /*yield*/, toTransportResponse(response)];
                    case 2:
                        result = _a.apply(void 0, [_b.sent()]);
                        return [2 /*return*/, result];
                }
            });
        });
    };
}
exports.fetchTransport = fetchTransport;
function toTransportResponse(res) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var headers, _b;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    headers = {};
                    res.headers.forEach(function (value, key) {
                        headers[key] = value;
                    });
                    _c = {
                        status: res.status,
                        statusText: res.statusText
                    };
                    if (!((_a = res.headers.get('content-type')) === null || _a === void 0 ? void 0 : _a.includes('application/json'))) return [3 /*break*/, 2];
                    return [4 /*yield*/, res.json()];
                case 1:
                    _b = _d.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, res.text()];
                case 3:
                    _b = _d.sent();
                    _d.label = 4;
                case 4: return [2 /*return*/, (_c.body = _b,
                        _c.headers = headers,
                        _c)];
            }
        });
    });
}
//# sourceMappingURL=fetch.js.map